import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const deleteTransport = async ({ clientId, addressId, transportId }) => {
  return await request.delete(
    `/HousingStock/transport/${transportId}`,
    {
      clientId,
      addressId,
    },
    'При удалении ТС произошла ошибка',
    'Error'
  );
};

const useDeleteTransport = () => {
  const mutation = useMutation(deleteTransport, {
    onSuccess: (data, { onSuccess }) => {
      if (data === 'Error') return;

      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    },
  });

  return {
    deleteTransport: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export default useDeleteTransport;
